import filtersStore from "@/app/strategies/store/filters";
import strategiesStore from "@/app/strategies/store/strategies";

export default {
  modules: {
    strategiesStore,
    filtersStore,
  },
};
